<template>
  <div class="shopinfo" v-if="Object.keys(storeInfo).length">
    <van-icon @click="showStore" name="shop" :class="'merchant-icon'" size="30" />
    <van-popup v-model="show" position="top" :class="'store-info'" :style="{ width: '100%' }">
      <myStore :store_name="merchant.title" :store_notice="merchant.announce" :star_value="parseInt(merchant.level)" :open="merchant.is_show==1" @evtCloseMyStore="closeStore" />
    </van-popup>
  </div>
</template>

<script>
import { cartMixin } from '@/mixins/cartMixin'
import myStore from '../index/myStore'

export default {
  name: 'shopinfo',
  components: { myStore },
  props:{
    storeInfo:{}
  },
  data () {
    return {
      show: false,
      merchant: {
        title: 'title',
        announce: 'announce',
        level: 4.5,
        is_show: 1,
      },
    };
  },
  created () {
    if(this.storeInfo){
      this.merchant = this.storeInfo
    }
  },
  mixins: [cartMixin],
  methods: {
    showStore () {
      this.show = true
    },
    closeStore () {
      this.show = false
    }
  }
};
</script>
<style lang="less">
@import url('../../assets/css/common.less');
.shopinfo {
  position: relative;
  top: 110px;
  .merchant-icon {
    position: fixed;
    top: 100px;
    right: 10px;
    border-radius: 50%;
    color: #fff;
    padding: 8px;
    background-color: hsla(0, 0%, 41.2%, 0.5);
  }
  .store-info {
    background-color: rgba(255, 255, 255, 0);
    color: #fff;
  }
}
</style>

